import React, { FC } from 'react'

export const ImageWider: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 3a1 1 0 0 1 0-2h10a1 1 0 1 1 0 2H5Zm14 4a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7ZM3 13V7h14v6H3Zm1 5a1 1 0 0 0 1 1h10a1 1 0 1 0 0-2H5a1 1 0 0 0-1 1Z"
      fill="#262628"
    />
  </svg>
)
